import React from 'react';
import RatingStars from './RatingStars';

const ServiceCard = ({ service, onServiceSelect }) => {
  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-PH', {
      style: 'currency',
      currency: 'PHP',
      minimumFractionDigits: 2
    }).format(price);
  };

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <i 
        key={index} 
        className={`fas fa-star ${index < Math.floor(rating) ? 'filled' : 'empty'}`}
      ></i>
    ));
  };

  const handleBookNow = (e) => {
    e.stopPropagation(); // Prevent card click
    // Open booking page in new tab
    const bookingUrl = `/booking?serviceId=${service.id}&title=${encodeURIComponent(service.title)}`;
    window.open(bookingUrl, '_blank');
  };

  // Original design for Stay services
  if (service.category === 'stay') {
    return (
      <div key={service.id} className="service-card" onClick={() => onServiceSelect(service)}>
        <div className="service-image" style={{ backgroundImage: `url(${service.image})` }}>
        </div>
        <div className="service-content">
          <div className="service-header">
            <h3>{service.title}</h3>
          </div>
          <RatingStars rating={service.rating} reviews={service.reviews} />
          {Array.isArray(service.features) && (
            <div className="service-features">
              {service.features.map((feature, index) => (
                <span key={index} className="feature-tag">{feature}</span>
              ))}
            </div>
          )}
          <div className="service-pricing">
            <div className="price-container">
              <span className="current-price">From PHP{service.price}</span>
            </div>
            <button className="book-service-btn-old" onClick={handleBookNow}>Book Now</button>
          </div>
        </div>
      </div>
    );
  }

  // Enhanced reference design for Experience services
  return (
    <div key={service.id} className="service-card experience-card" onClick={() => onServiceSelect(service)}>
      <div className="service-image experience-image">
        <img 
          src={service.image} 
          alt={service.title}
          onError={(e) => {
            e.target.style.display = 'none';
            e.target.parentElement.classList.add('image-error');
          }}
          onLoad={(e) => {
            e.target.parentElement.classList.remove('image-error');
          }}
        />
        {service.bestPrice && (
          <div className="best-price-badge">
            BEST<br/>PRICE
          </div>
        )}
      </div>
      <div className="service-content experience-content">
        <div className="experience-header">
          <h3 className="experience-title">{service.title}</h3>
        </div>
        
        <div className="experience-rating">
          {renderStars(service.rating || 4.0)}
        </div>
        
        <div className="experience-actions">
          {service.recommended && (
            <div className="recommended-badge-new">
              <i className="fas fa-check-circle"></i>
              RECOMMENDED
            </div>
          )}
          
          {/* <a href="#" className="view-package-link-new" onClick={(e) => e.stopPropagation()}>
            View Package
          </a> */}
        </div>
        
        <div className="experience-pricing">
          <button className="book-now-btn-new" onClick={handleBookNow}>BOOK NOW</button>
          <div className="price-info-new">
            {service.minPax ? (
              <>
                <span className="price-amount">Rate from {formatPrice(service.price || 0)}</span>
                <span className="price-details">per person min of {service.minPax} pax</span>
              </>
            ) : (
              <span className="price-amount">From {formatPrice(service.price || 0)}</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;